import { Currency } from '../../../constants/currency';
import type { Condition } from '../../../hooks/useProductData';
import { generateTermRange, getAmountRangeToString, getMinRateString, getTermBestEdgeString } from '../../humanization';

export const getBiznesCreditConditions = (item): Condition[] => {
  // Поля: Сумма, Срок. Ставка, без залога
  const conditions = [];

  const { minRate, maxRate, minSum, maxSum, dictDateFrom, dictDateTo, minTime, maxTime } = item;

  const rate = {
    from: minRate,
    to: maxRate,
  };

  const amount = {
    from: minSum,
    to: maxSum,
  };

  const rateValue = getMinRateString(rate, true);

  let rateDescription = 'ставка';
  if (item.dictAdvantages?.includes('factoring')) {
    rateDescription = 'комиссия';
  }
  if (item.rateTerm?.includes('year')) {
    rateDescription = `${rateDescription} в год`;
  } else {
    rateDescription = `${rateDescription} в месяц`;
  }
  conditions.push({ value: rateValue, description: rateDescription });

  if (item.dictAdvantages?.includes('nozalog')) {
    conditions.push({ value: 'Да', description: 'Без залога' });
  }

  const termRange = generateTermRange({
    dictDateFrom,
    from: minTime,
    dictDateTo,
    to: maxTime,
  });

  const termValue = getTermBestEdgeString(termRange, 'Индивидуально');

  const amountValue = getAmountRangeToString({ amountRange: amount, currency: Currency.RUB });

  conditions.push({
    value: amountValue,
    description: termValue.toLowerCase(),
    wide: true,
  });

  return conditions;
};
